const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { newsletterSearchQuerySchema } from "@circle-react/components/SettingsApp/Newsletters/searchQuerySchema";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const newsletterPostsSearchSchema = z.object({
  status: z.enum(["scheduled", "draft", "published"]).optional().catch(undefined),
  query: newsletterSearchQuerySchema
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/posts/")({
  validateSearch: newsletterPostsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});